import { render } from "./NotFoundComponent.vue?vue&type=template&id=5d34a96b&ts=true"
import script from "./NotFoundComponent.vue?vue&type=script&lang=ts"
export * from "./NotFoundComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__